import TermsAndConditionsPage from './TermsAndConditionsPage';
import i18n from '@/plugins/i18n.js';

export default [
  {
    path: '/terms-and-conditions',
    name: 'termsAndConditions',
    component: TermsAndConditionsPage,
    props: true,
    meta: {
      title: () => i18n.global.t('routes.pageTitles.termsAndConditions'),
      bypassOrgCheck: true,
      requiresAuth: false,
      hideSidebar: false,
      customHeader: true,
      fullScreen: true
    }
  }
];
